import React, {Component} from "react";

const AdvancedSearchContext = React.createContext();

const AdvancedSearchConsumer = AdvancedSearchContext.Consumer;

class AdvancedSearchProvider extends Component {
    // Context state
    state = {
        resIds: [],
        onSelectIds: [],
        chartIdGroup: ["0"],
        groupInfoListById: {},
        groupTypeListById: {},
        groupAccountListById: {},
        selectedNodesInfo: "",
        treemustrefresh: false,
        embeddedtreerefresh : false,
        outofcontextclic: "",
        architecture: [],
        page: "",
    };

    setPage = (page) => {
        this.setState((prevState) => ({page}));
    };

    // Method to update state
    setResIds = (resIds) => {
        this.setState((prevState) => ({resIds}));
    };

    setOnSelectIds = (onSelectIds) => {
        this.setState((prevState) => ({onSelectIds}));
    };

    setChartIdGroup = (chartIdGroup) => {
        this.setState((prevState) => ({chartIdGroup}));
    }

    setGroupInfoListById = (groupInfoListById) => {
        this.setState((prevState) => ({groupInfoListById}));
    }  

    setGroupTypeListById = (groupTypeListById) => {
        this.setState((prevState) => ({groupTypeListById}));
    }  

    setGroupAccountListById = (groupAccountListById) => {
        this.setState((prevState) => ({groupAccountListById}));
    }  
    
    setSelectedNodesInfo = (selectedNodesInfo) => {
        this.setState((prevState) => ({selectedNodesInfo}));
    }

    setTreemustrefresh = (treemustrefresh) => {
        this.setState((prevState) => ({treemustrefresh}));
    }

    setEmbeddedtreerefresh = (embeddedtreerefresh) => {
        this.setState((prevState) => ({embeddedtreerefresh}));
    }

    setGroupchanged = (groupchanged) => {
        this.setState((prevState) => ({groupchanged}));
    }

    setOutofcontextclic = (outofcontextclic) => {
        this.setState((prevState) => ({outofcontextclic}));
    }

    setArchitecture = (architecture) => {
        this.setState((prevState) => ({architecture}));
    }

    render() {
        const {children} = this.props;
        const {resIds} = this.state;
        const {setResIds} = this;
        const {onSelectIds} = this.state;
        const {setOnSelectIds} = this;
        const {chartIdGroup} = this.state;
        const {setChartIdGroup} = this;
        const {getNodeSelectChart} = this;
        const {groupInfoListById} = this.state;
        const {setGroupInfoListById} = this;
        const {groupTypeListById} = this.state;
        const {setGroupTypeListById} = this;
        const {groupAccountListById} = this.state;
        const {setGroupAccountListById} = this;
        const {selectedNodesInfo} = this.state;
        const {setSelectedNodesInfo} = this;
        const {treemustrefresh} = this.state;
        const {setTreemustrefresh} = this;
        const {embeddedtreerefresh} = this.state;
        const {setEmbeddedtreerefresh} = this;
        const {groupchanged} = this.state;
        const {setGroupchanged} = this;
        const {outofcontextclic} = this.state;
        const {setOutofcontextclic} = this;
        const {architecture} = this.state;
        const {setArchitecture} = this;
        const {page} = this.state;
        const {setPage} = this;
        return (
            <AdvancedSearchContext.Provider
                value={{
                    resIds,
                    setResIds,
                    onSelectIds,
                    setOnSelectIds,
                    chartIdGroup,
                    setChartIdGroup,
                    getNodeSelectChart,
                    groupInfoListById,
                    setGroupInfoListById,
                    groupTypeListById,
                    setGroupTypeListById,
                    groupAccountListById,
                    setGroupAccountListById,
                    setSelectedNodesInfo,
                    selectedNodesInfo,
                    treemustrefresh,
                    setTreemustrefresh,
                    embeddedtreerefresh,
                    setEmbeddedtreerefresh,
                    groupchanged,
                    setGroupchanged,
                    outofcontextclic,
                    setOutofcontextclic,
                    architecture,
                    setArchitecture,
                    page,
                    setPage,
                }}
            >
                {children}
            </AdvancedSearchContext.Provider>
        );
    }
}

export default AdvancedSearchContext;

export {AdvancedSearchProvider, AdvancedSearchConsumer};